import { render, staticRenderFns } from "./ProfileResultsTable.vue?vue&type=template&id=f3451fa6&scoped=true"
import script from "./ProfileResultsTable.vue?vue&type=script&lang=js"
export * from "./ProfileResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ProfileResultsTable.vue?vue&type=style&index=0&id=f3451fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3451fa6",
  null
  
)

export default component.exports